module.exports = __webpack_public_path__ + "static/media/S1_00017.cb798272.jpg";